import type { ReactNode } from "react";

/**
 * A long explanation folded to one line (audits/2026-10-29/gui/principles.md §4).
 *
 * 🔴 For explanations only — what a press does, what the reference says. Never for a
 * banner about the state X reports (`NO_CRITERIA`, `NO_TARGETING`, `startWarning`, the
 * production host, a create that may exist): those are what the layout promises are
 * seen without a click, and they stay `InfoBanner`. Unfolded, the text is the copy
 * constant as it stands; folding changes where it sits, never what it says.
 */
export interface FoldProps {
	/** The one line shown folded. */
	summary: ReactNode;
	children: ReactNode;
	className?: string;
}

export function Fold({ summary, children, className = "" }: FoldProps) {
	return (
		<details className={`rounded-md border border-line text-xs text-muted ${className}`.trim()}>
			<summary className="cursor-pointer select-none px-2 py-1 hover:text-content">
				{summary}
			</summary>
			<div className="px-2 pb-2">{children}</div>
		</details>
	);
}
